import { useState } from "react";

const langMeta = {
  ReactJS: { color: "#61dafb", label: "React" },
  JavaScript: { color: "#f1e05a", label: "JavaScript" },
  "Tailwind CSS": { color: "#06b6d4", label: "Tailwind CSS" },
  Solidity: { color: "#AA6746", label: "Solidity" },
  Python: { color: "#3572A5", label: "Python" },
  Django: { color: "#092e20", label: "Django" },
  CSS: { color: "#563d7c", label: "CSS" },
  HTML: { color: "#e34c26", label: "HTML" },
  "Material UI": { color: "#007fff", label: "Material UI" },
};

const getMainLang = (techs) =>
  langMeta[techs[0]] || { color: "var(--gh-text-secondary)", label: techs[0] };

const projects = [
  {
    name: "Inspacia - Interior Design Studio Website",
    fullName: "Inspacia interior design studio website",
    description:
      "Client-facing website for a premium interior design studio, delivered as part of my role at Beyondtax—translating brand aesthetics into a pixel-perfect, responsive React.js application. ",
    technologies: ["ReactJS", "Tailwind CSS", "Framer Motion"],
    liveLink: "https://www.inspacia.in/",
    category: "Web Application",
    stars: 0,
    forks: 0,
    updated: "Sep 2026",
    topics: ["react", "tailwindcss", "framer-motion", "interior-design", "responsive"],
  },
  {
    name: "Sign PDF",
    fullName: "akanshaBharti/sign-pdf",
    description:
      "PDF signing tool that lets users upload documents, place signatures with precision, and download ready-to-share signed PDFs through a simple, focused workflow.",
    technologies: ["ReactJS", "Django", "JavaScript", "CSS"],
    githubLink: "https://github.com/akanshaBharti/sign-pdf",
    liveLink: "https://github.com/akanshaBharti/sign-pdf",
    category: "Utility Tool",
    stars: 0,
    forks: 0,
    updated: "Jul 2026",
    topics: ["react", "django", "pdf", "signature", "fullstack"],
  },
  {
    name: "GreenThumb",
    fullName: "akanshaBharti/greenthumb",
    description:
      "Responsive and visually appealing plant care service platform. Showcases plant sales, care services, and interior plant design solutions.",
    technologies: ["ReactJS", "Tailwind CSS", "Framer Motion", "EmailJS"],
    githubLink: "https://github.com/akanshaBharti/greenthumb",
    liveLink: "https://greenthumb-space.vercel.app/",
    category: "Web Application",
    stars: 12,
    forks: 3,
    updated: "Mar 2025",
    topics: ["react", "tailwindcss", "framer-motion", "emailjs", "responsive"],
  },
  {
    name: "Tenancy",
    fullName: "akanshaBharti/tenancy-brand-ui",
    description:
      "Property rental website that enables tenants to search for homes in Hyderabad and choose from tailored accommodation plans (Premium, Standard, Shared).",
    technologies: ["ReactJS", "Tailwind CSS"],
    githubLink: "https://github.com/akanshaBharti/tenancy-brand-ui",
    liveLink: "https://tenancy-hyd.vercel.app/",
    category: "Web Application",
    stars: 7,
    forks: 1,
    updated: "Jan 2025",
    topics: ["react", "tailwindcss", "responsive"],
  },
  {
    name: "ByeWind Dashboard",
    fullName: "akanshaBharti/juspay-assign",
    description:
      "Modern, responsive React dashboard (ByeWind) with light and dark theme support, pixel-perfect attention to detail and meaningful micro-interactions.",
    technologies: ["ReactJS", "Tailwind CSS", "Framer Motion", "Recharts"],
    githubLink: "https://github.com/akanshaBharti/juspay-assign",
    liveLink: "https://byewind-juspay.vercel.app/",
    category: "Dashboard",
    stars: 18,
    forks: 5,
    updated: "Feb 2025",
    topics: ["react", "dashboard", "recharts", "dark-mode", "tailwindcss"],
  },
  {
    name: "Online Examination Portal",
    fullName: "Online-Examination-Portal/online_exam_ui",
    description:
      "Digital examination platform with intuitive and responsive UI, API integrations, and seamless user experience. Phase 1: Admin Panel.",
    technologies: ["ReactJS", "Material UI", "CSS"],
    githubLink: "https://github.com/Online-Examination-Portal/online_exam_ui",
    liveLink: "https://onlineexamination.netlify.app/",
    category: "Web Application",
    stars: 9,
    forks: 4,
    updated: "Dec 2024",
    topics: ["react", "material-ui", "exam-portal", "teamwork"],
  },
  {
    name: "Random Password Generator",
    fullName: "akanshaBharti/Random_Password_Generator",
    description:
      "Secure random password generator with customizable criteria. Copy-to-clipboard with one click. Works for emails, social media, and online accounts.",
    technologies: ["ReactJS", "Tailwind CSS"],
    githubLink: "https://github.com/akanshaBharti/Random_Password_Generator",
    liveLink: "https://randomcutomized-password-generator.vercel.app/",
    category: "Utility Tool",
    stars: 5,
    forks: 2,
    updated: "Nov 2024",
    topics: ["react", "tailwindcss", "security", "utility"],
  },
  {
    name: "drive-3.0",
    fullName: "akanshaBharti/drive-3.0",
    description:
      "Web 3.0 decentralized file sharing app on Polygon ZKEVM. IPFS storage, Ether.js blockchain interactions, smart contract integration.",
    technologies: [
      "ReactJS",
      "Solidity",
      "Ether.js",
      "IPFS",
      "Hardhat",
      "Tailwind CSS",
    ],
    githubLink: "https://github.com/akanshaBharti/0xCreators",
    liveLink: "https://github.com/akanshaBharti/0xCreators",
    category: "Web3 Application",
    stars: 15,
    forks: 6,
    updated: "Oct 2024",
    topics: ["web3", "solidity", "ipfs", "polygon", "react", "hardhat"],
  },
];

const types = [
  "All",
  "Web Application",
  "Dashboard",
  "Web3 Application",
  "Utility Tool",
];

const RepoCard = ({ repo }) => {
  const mainLang = getMainLang(repo.technologies);

  return (
    <div
      className="repo-card"
      style={{ display: "flex", flexDirection: "column", gap: 8 }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: 16,
        }}
      >
        {/* Left: name + desc */}
        <div style={{ flex: 1, minWidth: 0 }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              marginBottom: 6,
            }}
          >
            <svg
              aria-hidden="true"
              height="16"
              viewBox="0 0 16 16"
              width="16"
              style={{ fill: "var(--gh-text-secondary)", flexShrink: 0 }}
            >
              <path d="M2 2.5A2.5 2.5 0 0 1 4.5 0h8.75a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1 0-1.5h1.75v-2h-8a1 1 0 0 0-.714 1.7.75.75 0 1 1-1.072 1.05A2.495 2.495 0 0 1 2 11.5Zm10.5-1h-8a1 1 0 0 0-1 1v6.708A2.486 2.486 0 0 1 4.5 9h8Z" />
            </svg>
            <a
              href={repo.liveLink}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "var(--gh-link)",
                fontSize: 16,
                fontWeight: 600,
                textDecoration: "none",
              }}
              onMouseEnter={(e) =>
                (e.target.style.textDecoration = "underline")
              }
              onMouseLeave={(e) => (e.target.style.textDecoration = "none")}
            >
              {repo.name}
            </a>
            <span className="gh-badge gh-badge-blue" style={{ fontSize: 11 }}>
              Public
            </span>
          </div>

          <p
            style={{
              fontSize: 13,
              color: "var(--gh-text-secondary)",
              marginBottom: 8,
              lineHeight: 1.5,
            }}
          >
            {repo.description}
          </p>

          {/* Topics */}
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: 4,
              marginBottom: 10,
            }}
          >
            {repo.topics.map((t) => (
              <span key={t} className="gh-topic" style={{ fontSize: 11 }}>
                {t}
              </span>
            ))}
          </div>

          {/* Meta */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 16,
              fontSize: 12,
              color: "var(--gh-text-secondary)",
              flexWrap: "wrap",
            }}
          >
            <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <span
                style={{
                  width: 12,
                  height: 12,
                  borderRadius: "50%",
                  background: mainLang.color,
                  display: "inline-block",
                }}
              ></span>
              {mainLang.label}
            </span>
            {/* <button
              onClick={() => setStarred(s => !s)}
              style={{ display: "flex", alignItems: "center", gap: 4, background: "none", border: "none", cursor: "pointer", color: starred ? "var(--gh-yellow)" : "var(--gh-text-secondary)", padding: 0, fontSize: 12 }}
            >
              <svg height="14" viewBox="0 0 16 16" width="14" style={{ fill: starred ? "var(--gh-yellow)" : "currentColor" }}>
                <path d="M8 .25a.75.75 0 0 1 .673.418l1.882 3.815 4.21.612a.75.75 0 0 1 .416 1.279l-3.046 2.97.719 4.192a.75.75 0 0 1-1.088.791L8 12.347l-3.766 1.98a.75.75 0 0 1-1.088-.79l.72-4.194L.873 6.374a.75.75 0 0 1 .416-1.28l4.21-.611L7.327.668A.75.75 0 0 1 8 .25Z" />
              </svg>
              {repo.stars + (starred ? 1 : 0)}
            </button>
            <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <svg aria-hidden="true" height="14" viewBox="0 0 16 16" width="14" style={{ fill: "currentColor" }}>
                <path d="M5 5.372v.878c0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75v-.878a2.25 2.25 0 1 1 1.5 0v.878a2.25 2.25 0 0 1-2.25 2.25h-1.5v2.128a2.251 2.251 0 1 1-1.5 0V8.5h-1.5A2.25 2.25 0 0 1 3.5 6.25v-.878a2.25 2.25 0 1 1 1.5 0ZM5 3.25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Zm6.75.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm-3 8.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Z" />
              </svg>
              {repo.forks}
            </span>
            <span>Updated {repo.updated}</span> */}
          </div>
        </div>

        {/* Right: action buttons */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 6,
            flexShrink: 0,
          }}
        >
          {repo.githubLink && (
            <a
              href={repo.githubLink}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-gh"
              style={{ fontSize: 12, padding: "4px 12px" }}
            >
              <svg
                height="14"
                viewBox="0 0 16 16"
                width="14"
                style={{ fill: "currentColor" }}
              >
                <path d="M8 0c4.42 0 8 3.58 8 8a8.013 8.013 0 0 1-5.45 7.59c-.4.08-.55-.17-.55-.38 0-.27.01-1.13.01-2.2 0-.75-.25-1.23-.54-1.48 1.78-.2 3.65-.88 3.65-3.95 0-.88-.31-1.59-.82-2.15.08-.2.36-1.02-.08-2.12 0 0-.67-.22-2.2.82-.64-.18-1.32-.27-2-.27-.68 0-1.36.09-2 .27-1.53-1.03-2.2-.82-2.2-.82-.44 1.1-.16 1.92-.08 2.12-.51.56-.82 1.28-.82 2.15 0 3.06 1.86 3.75 3.64 3.95-.23.2-.44.55-.51 1.07-.46.21-1.61.55-2.33-.66-.15-.24-.6-.83-1.23-.82-.67.01-.27.38.01.53.34.19.73.9.82 1.13.16.45.68 1.31 2.69.94 0 .67.01 1.3.01 1.49 0 .21-.15.45-.55.38A7.995 7.995 0 0 1 0 8c0-4.42 3.58-8 8-8Z" />
              </svg>
              Code
            </a>
          )}
          {repo.liveLink !== repo.githubLink && (
            <a
              href={repo.liveLink}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-gh-green"
              style={{ fontSize: 12, padding: "4px 12px" }}
            >
              Live ↗
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

const Projects = () => {
  const [search, setSearch] = useState("");
  const [activeType, setActiveType] = useState("All");

  const filtered = projects.filter((p) => {
    const matchType = activeType === "All" || p.category === activeType;
    const matchSearch =
      search === "" ||
      p.name.toLowerCase().includes(search.toLowerCase()) ||
      p.description.toLowerCase().includes(search.toLowerCase()) ||
      p.topics.some((t) => t.includes(search.toLowerCase()));
    return matchType && matchSearch;
  });

  return (
    <div>
      {/* Header row */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 16,
          marginBottom: 20,
          flexWrap: "wrap",
        }}
      >
        {/* Search */}
        <div style={{ flex: "1 1 200px", position: "relative" }}>
          <svg
            aria-hidden="true"
            height="16"
            viewBox="0 0 16 16"
            width="16"
            style={{
              fill: "var(--gh-text-secondary)",
              position: "absolute",
              left: 10,
              top: "50%",
              transform: "translateY(-50%)",
            }}
          >
            <path d="M10.68 11.74a6 6 0 0 1-7.922-8.982 6 6 0 0 1 8.982 7.922l3.04 3.04a.749.749 0 0 1-.326 1.275.749.749 0 0 1-.734-.215ZM11.5 7a4.499 4.499 0 1 0-8.997 0A4.499 4.499 0 0 0 11.5 7Z" />
          </svg>
          <input
            type="text"
            className="gh-input"
            placeholder="Find a project..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{ paddingLeft: 34, height: 32 }}
          />
        </div>

        {/* Type filters */}
        <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
          {types.map((t) => (
            <button
              key={t}
              onClick={() => setActiveType(t)}
              style={{
                padding: "4px 12px",
                fontSize: 12,
                borderRadius: 6,
                cursor: "pointer",
                background:
                  activeType === t ? "var(--gh-link)" : "var(--gh-card)",
                color: activeType === t ? "var(--gh-bg)" : "var(--gh-text)",
                border: `1px solid ${activeType === t ? "var(--gh-link)" : "var(--gh-border)"}`,
                fontWeight: activeType === t ? 600 : 400,
                transition: "all 0.15s",
              }}
            >
              {t}
            </button>
          ))}
        </div>

        {/* Stats */}
        {/* <div style={{ display: "flex", gap: 12, fontSize: 13, color: "var(--gh-text-secondary)" }}>
          <span><strong style={{ color: "var(--gh-text)" }}>{totalStars}</strong> total stars</span>
          <span><strong style={{ color: "var(--gh-text)" }}>{projects.length}</strong> repos</span>
        </div> */}
      </div>

      {/* Repo list */}
      {filtered.length === 0 ? (
        <div
          style={{
            textAlign: "center",
            padding: 48,
            color: "var(--gh-text-secondary)",
          }}
        >
          {/* <svg aria-hidden="true" height="64" viewBox="0 0 16 16" width="64" style={{ fill: "var(--gh-border)", marginBottom: 16 }}>
            <path d="M2 2.5A2.5 2.5 0 0 1 4.5 0h8.75a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1 0-1.5h1.75v-2h-8a1 1 0 0 0-.714 1.7.75.75 0 1 1-1.072 1.05A2.495 2.495 0 0 1 2 11.5Zm10.5-1h-8a1 1 0 0 0-1 1v6.708A2.486 2.486 0 0 1 4.5 9h8Z" />
          </svg> */}
          <p>No project match your search.</p>
        </div>
      ) : (
        <div>
          {filtered.map((repo, i) => (
            <RepoCard key={i} repo={repo} />
          ))}
        </div>
      )}

      {/* Language breakdown */}
      <div
        style={{
          marginTop: 32,
          background: "var(--gh-surface)",
          border: "1px solid var(--gh-border)",
          borderRadius: 6,
          padding: 20,
        }}
      >
        <h3
          style={{
            fontSize: 14,
            fontWeight: 600,
            color: "var(--gh-text)",
            marginBottom: 16,
          }}
        >
          Languages across projects
        </h3>
        <div
          style={{
            display: "flex",
            height: 8,
            borderRadius: 4,
            overflow: "hidden",
            marginBottom: 16,
          }}
        >
          {[
            { color: "#61dafb", pct: 70 },
            { color: "#f1e05a", pct: 15 },
            { color: "#06b6d4", pct: 8 },
            { color: "#AA6746", pct: 4 },
            { color: "#007fff", pct: 3 },
          ].map((l, i) => (
            <div key={i} style={{ width: `${l.pct}%`, background: l.color }} />
          ))}
        </div>
        <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
          {[
            { label: "React", color: "#61dafb", pct: 70 },
            { label: "JavaScript", color: "#f1e05a", pct: 15 },
            { label: "Tailwind CSS", color: "#06b6d4", pct: 8 },
            { label: "Solidity", color: "#AA6746", pct: 4 },
            { label: "Material UI", color: "#007fff", pct: 3 },
          ].map((l) => (
            <span
              key={l.label}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 6,
                fontSize: 12,
                color: "var(--gh-text-secondary)",
              }}
            >
              <span
                style={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  background: l.color,
                  display: "inline-block",
                }}
              ></span>
              <span style={{ color: "var(--gh-text)" }}>{l.label}</span>
              <span>{l.pct}%</span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Projects;
